/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import makeStyles from '@mui/styles/makeStyles';

const createFooterStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '20px 25px',
    backgroundColor: '#ffffff',
  },
  footer_copyright: {
    fontSize: '13px',
    textDecoration: 'none',
    color: theme.palette.text.primary,
  },
  footer_menu_link: {
    textDecoration: 'none',
    margin: '0 0 0 1.25rem',
    fontWeight: 400,
    color: theme.palette.text.primary,
    display: 'inline-block',
    cursor: 'pointer',
    fontSize: '13px',
  },
}));

export { createFooterStyles };
